import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { handleSupabaseError, insertWithUserId } from "@/lib/hooks/api/utils";

export function useCreateTicketUpdate() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({
      ticket_id,
      update_type,
      content,
      is_internal = false,
    }: {
      ticket_id: string;
      update_type: string;
      content: string;
      is_internal?: boolean;
    }) => {
      const { data, error } = await insertWithUserId("ticket_updates", {
        ticket_id,
        update_type,
        content,
        is_internal,
      });

      if (error) {
        handleSupabaseError(error, "create ticket update");
      }

      return data;
    },
    onSuccess: (data, variables) => {
      void queryClient.invalidateQueries({ queryKey: ["tickets"] });
      void queryClient.invalidateQueries({ queryKey: ["ticket", variables.ticket_id] });
      void queryClient.invalidateQueries({ queryKey: ["ticket-updates", variables.ticket_id] });
      toast.success("Ticket update added successfully");
    },
    onError: (error) => {
      toast.error("Failed to add ticket update");
      console.error("Error creating ticket update:", error);
    },
  });
}
